<footer class="bg-dark text-white border-top border-light-subtle mt-auto py-4">
  <div class="container">
    <div class="row align-items-center gy-3">

      
      <div class="col-12 col-md-4 text-center text-md-start">
        <div class="d-flex align-items-center justify-content-center justify-content-md-start gap-1 mb-1">
          <mat-icon class="text-white">auto_stories</mat-icon>
          <span class="fw-semibold">Vocabulary</span>
        </div>
        <small class="text-white-50">&copy; {{ currentYear }} All rights reserved</small>
      </div>

      
      <div class="col-12 col-md-8">
        <div class="d-flex flex-wrap justify-content-center justify-content-md-end align-items-center gap-1">
          <a mat-button class="rounded-pill text-white-50" routerLink="/about">About</a>
          <a mat-button class="rounded-pill text-white-50" routerLink="/privacy">Privacy</a>
          <a mat-button class="rounded-pill text-white-50" routerLink="/terms">Terms</a>
          <a mat-button class="rounded-pill text-white-50" routerLink="/cookies">Cookies</a>

          <div class="vr mx-1 d-none d-sm-inline-flex text-white-50"></div>

          <button mat-stroked-button class="rounded-pill text-white border-white border-opacity-50"
            [matMenuTriggerFor]="contactMenu">
            <mat-icon class="text-white">mail_outline</mat-icon> Contact
          </button>
          <mat-menu #contactMenu="matMenu" yPosition="above">
            <a mat-menu-item
              href="mailto:support@myvocabulary.net?subject=Vocabulary%20-%20Feature%20Request"
              target="_blank" rel="noopener">
              <mat-icon>lightbulb</mat-icon> Request a Feature
            </a>
            <a mat-menu-item
              href="mailto:support@myvocabulary.net?subject=Vocabulary%20-%20Bug%20Report"
              target="_blank" rel="noopener">
              <mat-icon>bug_report</mat-icon> Report a Problem
            </a>
          </mat-menu>
        </div>
      </div>

    </div>
  </div>
</footer>
